import React from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import AdminTable from "../Administrator/Helpers/AdminTable"
import {
  getAbonementsClient,
  getAbonementsList,
  getClientTrainings,
  getClientsList,
  commentsAction,
  getReport,
  getCode,
  getLink,
  getTransactions,
  getPersonalPacket,
  getPacketsList,
  deletePhoneNumber,
  blockClient,
} from "src/store/Slices/ClientsSlice"
import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import { Button, Checkbox, Popover, Select, Switch, Modal, Input, DatePicker, message } from "antd"
import ClientsExtraTable from "./Tables/ClientsExtraTable"
import AddEditClientModal from "./Modals/AddEditClientModal"
import EditManagerModal from "./Modals/EditManagerModal"
import { formateDate } from "src/components/helpers/formateDate"
import MobileClientsNew from "./Mobile/MobileClientsNew"
import MailModal from "./Modals/MailModal"
import dayjs from "dayjs"
import plus from "./free-icon-plus-5948495 2.png"
import AddComment from "./Modals/AddComment"
import {
  getFilterTypes,
  getReportTypes,
  getMonths,
} from "src/store/Slices/DropDownSlice"
import {
  downloadReportXlsx,
  buildBody,
  buildAdditionaldBody,
} from "src/components/helpers/downloadReport"
import ReportModal from "./Modals/ReportModal"
import FilterModal from "./Modals/FilterModal"
import CodeModal from "./Modals/CodeModal"
import AddAgreeModal from "./Modals/AddAgreeModal"
import WatchAgreeModal from "./Modals/WatchAgreeModal"
import AddStatus from "./Modals/AddStatus"
import CertificatePaymentModal from "./Modals/CertificatePaymentModal"
import { DownOutlined, UpOutlined } from "@ant-design/icons"

// Компонент модального окна для блокировки
const BlockClientModal = ({ visible, setVisible, clientInfo, onConfirm, loading }) => {
  const [reason, setReason] = useState("")
  const [unblockDate, setUnblockDate] = useState(null)

  const handleConfirm = async () => {
    if (!reason.trim()) {
      message.error("Пожалуйста, укажите причину блокировки")
      return
    }

    console.log("unblockDate", dayjs(unblockDate).format("YYYY-MM-DD HH:mm:ss"))

    await onConfirm({
      userId: clientInfo?.id,
      reason: reason,
      toDate: unblockDate ? dayjs(unblockDate).format("YYYY-MM-DD HH:mm:ss") : null
    })
    
    // Сбрасываем форму после успешной блокировки
    setReason("")
    setUnblockDate(null)
  }

  const handleCancel = () => {
    setVisible(false)
    setReason("")
    setUnblockDate(null)
  }

  return (
    <Modal
      title="Блокировка клиента"
      open={visible}
      onOk={handleConfirm}
      onCancel={handleCancel}
      confirmLoading={loading}
      centered
      okText="Заблокировать"
      cancelText="Отмена"
      okButtonProps={{ danger: true, style: { backgroundColor: "#ff4d4f" } }}
      width={500}
    >
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 8, fontWeight: 500, color: "#262626" }}>
          Причина блокировки 
        </div>
        <Input.TextArea
          rows={4}
          placeholder="Введите причину блокировки..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={500}
          showCount
          status={!reason.trim() && visible ? undefined : undefined}
        />
      </div>

      <div>
        <div style={{ marginBottom: 8, fontWeight: 500, color: "#262626" }}>
          Автоматическая разблокировка
        </div>
        <DatePicker
          placeholder="Выберите дату и время разблокировки"
          value={unblockDate}
          onChange={(date) => setUnblockDate(date)}
          format="DD.MM.YYYY HH:mm"
          style={{ width: "100%" }}
          showTime={{ format: "HH:mm" }}
          disabledDate={(current) => current && current < dayjs().startOf("day")}
        />
      
      </div>
    </Modal>
  )
}

const ClientsNew = ({ mnemo }) => {
  let result = localStorage.getItem("result")
  
  const dispatch = useDispatch()
  
  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "edit" })
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица клиентов")
        ?.children.find((ele) => ele.mnemo === "updateBtn"),
    },
    {
      key: "2",
      onClick: () => {
        setCodeModal(true)
      },
      label: "Получить код",
    },
    {
      key: "3",
      onClick: () => {
        setIsEditManagerModal(true)
      },
      label: "Добавить менеджера",
    },
    {
      key: "4",
      onClick: () => {
        setIsAddAgreeModal(true)
      },
      label: "Добавить соглашение",
    },
    {
      key: "5",
      onClick: () => {
        setIsWatchAgreeModal(true)
      },
      label: "Посмотреть соглашение",
    },
    {
      key: "6",
      onClick: async () => {
        try {
          const result = await dispatch(
            deletePhoneNumber({ userId: clientInfo?.id }),
          )
          console.log("result: ", result)
          if (result.payload?.data?.isSuccess === true) {
            message.success("Номер телефона успешно отвязан")
            dispatch(getClientsList(addEditPayload))
            setClientInfo(null)
          } else {
            message.error("Ошибка при отвязке номера")
          }
        } catch (error) {
          message.error("Произошла ошибка")
        }
      },
      label: "Отвязать номер",
    },
  ]

  const [tab, setTab] = useState("Клиенты")
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [clientInfo, setClientInfo] = useState()
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
    open: false,
    flag: "",
  })
  const [isOpenAddMailModal, setIsOpenAddMailModal] = useState({ open: false })
  const [isOpenCertificatePaymentModal, setIsOpenCertificatePaymentModal] = useState(false)
  const [isEditManagerModal, setIsEditManagerModal] = useState(false)
  const [isAddAgreeModal, setIsAddAgreeModal] = useState(false)
  const [isWatchAgreeModal, setIsWatchAgreeModal] = useState(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [activeAbonement, setActiveAbonement] = useState(true)
  const [allActive, setAllActive] = useState(false)
  const [inActiveAbonement, setInActiveAbonement] = useState(true)
  const [tabPage, setTabPage] = useState("Абонементы")
  const [checkers, setCheckers] = useState(false)
  const [reportInfo, setReportInfo] = useState({ mnemo: "", value: null })
  const [filterInfo, setFilterInfo] = useState({ mnemo: "", value: null })
  const [monthsInfo, setMonthsInfo] = useState({ mnemo: "", value: null })
  const [clientMarkedList, setClientMarkedList] = useState([])
  const [isOpenAddCommentModal, setIsOpenAddCommentModal] = useState(false)
  const [isOpenAddStatusModal, setIsOpenAddStatusModal] = useState(false)
  const [filters, setFilters] = useState()
  const [reportModalOpen, setReportModalOpen] = useState(false)
  const [filterModalOpen, setFilterModalOpen] = useState({
    open: false,
    type: "",
    twoField: false,
  })
  const [addEditPayload, setAddEditPayload] = useState({})
  const [codeModal, setCodeModal] = useState(false)
  const [additionalFilters, setAdditionalFilters] = useState({})
  const [activeFilters, setActiveFilters] = useState({})
  const [selected, setSelected] = useState([])
  
  // Состояния для блокировки
  const [isBlockModalVisible, setIsBlockModalVisible] = useState(false)
  const [pendingBlockUser, setPendingBlockUser] = useState(null)
  const [blockLoading, setBlockLoading] = useState(false)

  // STORE
  const clientsList = useSelector((state) => state.ClientsSlice.clientsList)
  const clientsListLoading = useSelector(
    (state) => state.ClientsSlice.clientsListLoading,
  )
  const reportData = useSelector((state) => state.ClientsSlice.reportData)
  const reportTypes = useSelector((state) => state.DropDownSlice.reportTypes)
  const filterTypes = useSelector((state) => state.DropDownSlice.filterTypes)
  const filterMonths = useSelector((state) => state.DropDownSlice.months)
  const [showFilters, setShowFilters] = useState(false)

  const setNullMarkedClients = () => {
    setClientMarkedList([])
  }

  const getReportHandler = (reportName) => {
    const body = buildBody(reportName, addEditPayload)
    console.log(body)
    dispatch(getReport(body)).then((value) => {
      downloadReportXlsx(value.payload)
    })
  }

  const getAdditionalReportHandler = () => {
    const body = buildAdditionaldBody(reportInfo.mnemo)
    console.log(body)
    dispatch(getReport(body)).then((value) => {
      downloadReportXlsx(value.payload)
    })
  }

  useEffect(() => {
    if (reportInfo.mnemo !== "" && reportInfo.value !== 3) {
      setReportModalOpen(true)
    } else if (reportInfo.value === 3) {
      setReportModalOpen(false)
    }
  }, [reportInfo])

  useEffect(() => {
    switch (filterInfo.value) {
      case 1: {
        setAddEditPayload({
          ...addEditPayload,
          "AbonementDateEnd.From": null,
          "AbonementDateEnd.To": null,
          "AbonementDateStart.From": null,
          "AbonementDateStart.To": null,
        })
        setAdditionalFilters({})
        dispatch(
          getClientsList({
            ...addEditPayload,
            "AbonementDateEnd.From": null,
            "AbonementDateEnd.To": null,
            "AbonementDateStart.From": null,
            "AbonementDateStart.To": null,
          }),
        ).then(() => {
          setFilterInfo({ mnemo: "", value: null })
        })
        break
      }
      case 3: {
        setFilterModalOpen({ open: true, type: "end", twoField: false })
        break
      }
      case 4: {
        setFilterModalOpen({ open: true, type: "end", twoField: true })
        break
      }
      case 5: {
        setFilterModalOpen({ open: true, type: "start", twoField: false })
        break
      }
      case 6: {
        setFilterModalOpen({ open: true, type: "start", twoField: true })
        break
      }
      default: {
        break
      }
    }
  }, [filterInfo])

  useEffect(() => {
    if (activeAbonement && !inActiveAbonement) {
      setActiveFilters({ AbonementClub: true })
      setAddEditPayload((prev) => {
        return { ...prev, AbonementClub: true }
      })
      dispatch(getClientsList({ ...addEditPayload, AbonementClub: true }))
    } else if (!activeAbonement && inActiveAbonement) {
      setActiveFilters({ AbonementClub: false })
      setAddEditPayload((prev) => {
        return { ...prev, AbonementClub: false }
      })
      dispatch(getClientsList({ ...addEditPayload, AbonementClub: false }))
    } else if (!activeAbonement && !inActiveAbonement) {
      setActiveFilters({ Count: 0 })
      setAddEditPayload((prev) => {
        return { ...prev, Count: 0 }
      })
      dispatch(getClientsList({ ...addEditPayload, Count: 0 }))
    } else {
      setActiveFilters({})
      setAddEditPayload((prev) => {
        return { ...prev, AbonementClub: null }
      })
      dispatch(getClientsList({ ...addEditPayload, AbonementClub: null }))
    }
  }, [activeAbonement, inActiveAbonement])

  useEffect(() => {
    dispatch(getReportTypes())
  }, [dispatch])

  const handleChangeByMonth = (values) => {
    const abonementLength = values.map(Number)
    setSelected(abonementLength)
    dispatch(
      getClientsList({
        abonementLength: abonementLength,
      }),
    )
  }

  // Функция для блокировки/разблокировки клиента
  const handleBlockClient = async (userId, shouldBlock) => {
    if (shouldBlock) {
      // Если нужно заблокировать - открываем модальное окно
      setPendingBlockUser(userId)
      setIsBlockModalVisible(true)
    } else {
      // Если разблокируем - выполняем сразу
      try {
        setBlockLoading(true)
        const result = await dispatch(blockClient({
          userId: userId,
          ban: false,
          reason: null,
          unblockDate: null
        }))
        if (result.payload?.data?.isSuccess === true) {
          message.success("Пользователь разблокирован")
          dispatch(getClientsList(addEditPayload))
        } else {
          message.error("Ошибка при разблокировке")
        }
      } catch (error) {
        console.error("Error:", error)
        message.error("Произошла ошибка")
      } finally {
        setBlockLoading(false)
      }
    }
  }

  // Подтверждение блокировки с причиной и датой
  const confirmBlockClient = async ({ userId, reason, toDate }) => {
    try {
      setBlockLoading(true)
      console.log("ХУЙНЯ", toDate)
      const result = await dispatch(blockClient({
        userId: userId,
        ban: true,
        reason: reason,
        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD HH:mm:ss") : null
      }))
      if (result.payload?.data?.isSuccess === true) {
        message.success("Пользователь заблокирован")
        dispatch(getClientsList(addEditPayload))
        setIsBlockModalVisible(false)
      } else {
        message.error("Ошибка при блокировке")
      }
    } catch (error) {
      console.error("Error:", error)
      message.error("Произошла ошибка")
    } finally {
      setBlockLoading(false)
      setPendingBlockUser(null)
    }
  }

  const title = () => {
    const [isCollapsed, setIsCollapsed] = useState(true)

    return (
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          marginBottom: 0,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
            borderBottom: isCollapsed ? "none" : "1px solid #f0f0f0",
            cursor: "pointer",
            userSelect: "none",
            minHeight: "60px",
          }}
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <CNav variant='tabs'>
              <CNavItem>
                <CNavLink
                  style={{
                    fontWeight: 500,
                    borderRadius: "6px 6px 0 0",
                  }}
                  active={true}
                >
                  Клиенты
                </CNavLink>
              </CNavItem>
            </CNav>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <CButton
                disabled={
                  !mnemo?.children
                    ?.find((el) => el.name === "Таблица клиентов")
                    ?.children.find((ele) => ele.mnemo === "insertBtn")
                }
                onClick={() =>
                  setIsOpenAddEditModal({ open: true, flag: "add" })
                }
                style={{
                  color: "#fff",
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                }}
              >
                Добавить
              </CButton>

              <CButton
                disabled={
                  !mnemo?.children
                    ?.find((el) => el.name === "Таблица клиентов")
                    ?.children.find((ele) => ele.mnemo === "insertBtn")
                }
                onClick={() => setCheckers(!checkers)}
                style={{
                  color: "#fff",
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                  opacity: checkers ? 1 : 0.9,
                }}
              >
                {checkers ? "✓ Режим меток" : "Режим меток"}
              </CButton>

              <CButton
                disabled={clientMarkedList.length === 0}
                onClick={() => setClientMarkedList([])}
                style={{
                  color: "#fff",
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                }}
              >
                Снять метки
              </CButton>

              <CButton
                onClick={() => setIsOpenAddMailModal({ open: true })}
                style={{
                  color: "#fff",
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                }}
              >
                Рассылки
              </CButton>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "2px 6px",
                  background: checkers ? "#e6f7ff" : "#fafafa",
                  border: checkers ? "1px solid #91d5ff" : "1px solid #f0f0f0",
                  borderRadius: "6px",
                  minWidth: "200px",
                  opacity: checkers ? 1 : 0.7,
                }}
              >
                <Checkbox
                  checked={allActive}
                  disabled={!checkers}
                  onChange={() => setAllActive(!allActive)}
                  style={{ transform: "scale(1.2)" }}
                />
                <div>
                  <div
                    style={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: "#262626",
                    }}
                  >
                    Выбрать всех
                  </div>
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#8c8c8c",
                      marginTop: "2px",
                    }}
                  >
                    {checkers
                      ? "Выбрать всех клиентов"
                      : "Включите режим меток"}
                  </div>
                </div>
              </div>
              <CButton
                onClick={() => setIsOpenCertificatePaymentModal(true)}
                style={{
                  color: "#fff",
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                }}
              >
                Оплатить сертификат
              </CButton>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "20px",
              minWidth: "40px",
            }}
          >
            <Button
              type='text'
              icon={isCollapsed ? <DownOutlined /> : <UpOutlined />}
              onClick={(e) => {
                e.stopPropagation()
                setIsCollapsed(!isCollapsed)
              }}
              style={{
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                color: "#8c8c8c",
              }}
            />
          </div>
        </div>

        {!isCollapsed && (
          <div
            style={{
              padding: "10px",
              backgroundColor: "#fafafa",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <div
              style={{
                padding: "15px",
                background: "#fff",
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                marginBottom: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: "1 1 100px" }}>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#595959",
                      marginBottom: "4px",
                    }}
                  >
                    Выбрать отчёт
                  </div>
                  <Select
                    placeholder='Выбрать отчёт'
                    value={reportInfo.value}
                    onChange={(value) =>
                      setReportInfo({
                        mnemo: reportTypes?.data?.value?.find(
                          (el) => el.value === value,
                        )?.mnemo,
                        value: value,
                      })
                    }
                    options={reportTypes?.data?.value}
                    style={{ width: "100%" }}
                    size='small'
                  />
                </div>

                <div style={{ flex: "0 0 auto", marginTop: "5px" }}>
                  <CButton
                    style={{
                      color: "#fff",
                      height: "32px",
                      minWidth: "120px",
                      fontSize: "13px",
                      borderRadius: "6px",
                      boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                    }}
                    onClick={() => {
                      if (reportInfo?.value === 3) {
                        getAdditionalReportHandler()
                      } else {
                        getReportHandler("GetClientsReport")
                      }
                    }}
                  >
                    Скачать отчёт
                  </CButton>
                </div>

                <div style={{ flex: "1 1 200px" }}>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#595959",
                      marginBottom: "4px",
                    }}
                  >
                    Выбрать фильтр
                  </div>
                  <Select
                    placeholder='Выбрать фильтр'
                    onClick={() => dispatch(getFilterTypes())}
                    value={filterInfo.value}
                    onChange={(value) =>
                      setFilterInfo({
                        mnemo: filterTypes?.data?.value?.find(
                          (el) => el.value === value,
                        )?.mnemo,
                        value: value,
                      })
                    }
                    options={filterTypes?.data?.value}
                    style={{ width: "100%" }}
                    size='small'
                  />
                </div>

                <div style={{ flex: "1 1 200px" }}>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#595959",
                      marginBottom: "4px",
                    }}
                  >
                    Длительность абонемента
                  </div>
                  <Select
                    mode='multiple'
                    placeholder='Выбрать длительность'
                    allowClear
                    onClick={() => dispatch(getMonths())}
                    value={selected}
                    onChange={handleChangeByMonth}
                    options={filterMonths?.data?.value}
                    style={{ width: "100%" }}
                    size='small'
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                padding: "15px",
                background: "#fff",
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Checkbox
                    checked={activeAbonement}
                    disabled={!inActiveAbonement}
                    onChange={() => setActiveAbonement((prev) => !prev)}
                    style={{ transform: "scale(1.1)" }}
                  />
                  <div>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      С активным абонементом
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#8c8c8c",
                        marginTop: "2px",
                      }}
                    >
                      (ЧК) Клиенты с активным абонементом
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Checkbox
                    checked={inActiveAbonement}
                    disabled={!activeAbonement}
                    onChange={() => setInActiveAbonement((prev) => !prev)}
                    style={{ transform: "scale(1.1)" }}
                  />
                  <div>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#262626",
                      }}
                    >
                      Без активного абонемента
                    </div>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#8c8c8c",
                        marginTop: "2px",
                      }}
                    >
                      (ПЧК) Клиенты без активного абонемента
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0]
            formattedItems["idTo"] = values[index][1]
          } else if (key === "birthday") {
            formattedItems["BirthdayFrom"] = values[index][0]
            formattedItems["BirthdayTo"] = values[index][1]
          } else if (key === "club") {
            formattedItems["ClubId"] = values[index][0]
          } else if (key === "isCompleted") {
            formattedItems["IsCompleted"] = values[index][0]
          } else if (key === "contactDate") {
            formattedItems["ContactDate.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD",
            )
            formattedItems["ContactDate.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD",
            )
          } else if (key === "lastAbonementBuyDate") {
            formattedItems["lastAbonementBuyDate.From"] = dayjs(
              values[index][0],
            ).format("YYYY-MM-DD")
            formattedItems["lastAbonementBuyDate.To"] = dayjs(
              values[index][1],
            ).format("YYYY-MM-DD")
          } else if (key === "task") {
            formattedItems["task.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD",
            )
            formattedItems["task.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD",
            )
          } else if (key === "status") {
            formattedItems["statusId"] = values[index][0]
          } else {
            formattedItems[key] = values[index][0]
          }
        }
      })
      console.log("formatedItems", formattedItems["status"])
      return formattedItems
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
    dispatch(
      getClientsList({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        ...payload,
        ...additionalFilters,
        ...activeFilters,
      }),
    )
    setAddEditPayload({
      count: pagination.pageSize,
      offset: pagination.pageSize * (pagination.current - 1),
      orderBy: sorter?.column?.dataIndex,
      isDesc: sorter.order
        ? sorter.order === "ascend"
          ? true
          : false
        : undefined,
      ...payload,
      ...additionalFilters,
      ...activeFilters,
    })
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
    setFilters(payload)
  }

  const rowClassName = (record) => {
    return record?.key === clientInfo?.key ? "selected-row" : ""
  }

  const onClickRowOne = (record) => {
    setClientInfo(record)
    dispatch(getAbonementsClient({ clientId: record.id }))
    dispatch(getClientTrainings({ clientId: record.id }))
    dispatch(getTransactions({ UserId: record.id }))
    dispatch(getLink({ flag: "get", value: { UserId: record.id } }))
    dispatch(commentsAction({ flag: "get", value: { UserId: record.id } }))
    dispatch(getPersonalPacket({ flag: "get", value: { UserId: record.id } }))
  }

  useEffect(() => {
    dispatch(getAbonementsList())
    dispatch(getClientsList())
    dispatch(getPacketsList())
  }, [])

  const formatedClientsRows = clientsList?.data?.value?.rows.map((element) => {
    return {
      ...element,
      birthday: element.birthday && formateDate(element.birthday),
      isBlocked: (
        <Switch
          checked={element.isBlocked}
          onChange={(checked) => handleBlockClient(element.id, checked)}
          loading={blockLoading && pendingBlockUser === element.id}
        />
      ),
      status: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {element.status ? element.status : "-"}
          <CButton
            size='sm'
            style={{ border: "none", height: "16px", padding: "0" }}
            onClick={() => {
              setIsOpenAddStatusModal(true)
            }}
            disabled={
              !mnemo?.children
                ?.find((el) => el.name === "Таблица комментов")
                ?.children.find((ele) => ele.mnemo === "insertBtn")
            }
          >
            <img
              style={{ color: "#fff", cursor: "pointer", marginBottom: "9px" }}
              src={plus}
              alt="plus"
            />
          </CButton>
        </div>
      ),
      comment: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {element.comment ? element.comment : "-"}
          <CButton
            size='sm'
            style={{ border: "none", height: "16px", padding: "0" }}
            onClick={() => {
              setIsOpenAddCommentModal(true)
            }}
            disabled={
              !mnemo?.children
                ?.find((el) => el.name === "Таблица комментов")
                ?.children.find((ele) => ele.mnemo === "insertBtn")
            }
          >
            <img
              style={{ color: "#fff", cursor: "pointer", marginBottom: "9px" }}
              src={plus}
              alt="plus"
            />
          </CButton>
        </div>
      ),
      isCompleted:
        element?.isCompleted != null && (element?.isCompleted ? "Да" : "Нет"),
    }
  })

  return (
    <>
      <EditManagerModal
        visible={isEditManagerModal}
        setVisible={setIsEditManagerModal}
        clientInfo={clientInfo}
        addEditPayload={addEditPayload}
      />
      <AddAgreeModal
        visible={isAddAgreeModal}
        setVisible={setIsAddAgreeModal}
        clientInfo={clientInfo}
      />
      {WatchAgreeModal && (
        <WatchAgreeModal
          visible={isWatchAgreeModal}
          setVisible={setIsWatchAgreeModal}
          clientInfo={clientInfo}
        />
      )}
      <CodeModal
        codeModal={codeModal}
        setCodeModal={setCodeModal}
        clientInfo={clientInfo}
      />
      <MailModal
        visible={isOpenAddMailModal}
        setVisible={setIsOpenAddMailModal}
        clientInfo={clientMarkedList}
        clientsList={clientsList}
        setPage={setPage}
        setPageSize={setPageSize}
        setClientMarkedList={setClientMarkedList}
        allActive={allActive}
        setAllActive={setAllActive}
      />
      <CertificatePaymentModal 
        visible={isOpenCertificatePaymentModal}
        setVisible={setIsOpenCertificatePaymentModal}
        clientInfo={clientMarkedList}
      />
      <AddEditClientModal
        visible={isOpenAddEditModal}
        setVisible={setIsOpenAddEditModal}
        clientInfo={clientInfo}
        setPage={setPage}
        setPageSize={setPageSize}
        addEditPayload={addEditPayload}
      />
      <AddComment
        commentModal={isOpenAddCommentModal}
        setCommentModal={setIsOpenAddCommentModal}
        clientInfo={clientInfo}
      />
      <AddStatus
        statusModal={isOpenAddStatusModal}
        setStatusModal={setIsOpenAddStatusModal}
        clientInfo={clientInfo}
      />
      <ReportModal
        commentModal={reportModalOpen}
        setCommentModal={setReportModalOpen}
        reportInfo={reportInfo}
        setReportInfo={setReportInfo}
      />
      <FilterModal
        addEditPayload={addEditPayload}
        setAddEditPayload={setAddEditPayload}
        additionalFilters={additionalFilters}
        setAdditionalFilters={setAdditionalFilters}
        commentModal={filterModalOpen}
        setCommentModal={setFilterModalOpen}
        setFilterInfo={setFilterInfo}
      />
      
      {/* Модальное окно блокировки */}
      <BlockClientModal
        visible={isBlockModalVisible}
        setVisible={setIsBlockModalVisible}
        clientInfo={{ id: pendingBlockUser }}
        onConfirm={confirmBlockClient}
        loading={blockLoading}
      />

      {window.innerWidth >= 768 ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <AdminTable
            scroll={{ x: 0, y: 500 }}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            onChange={handleTableChange}
            loading={clientsListLoading}
            onClickRowOne={onClickRowOne}
            columns={clientsList}
            rows={formatedClientsRows}
            total={clientsList?.data?.value?.totalCount}
            title={title}
            items={items}
            checkers={checkers}
            clientMarkedList={clientMarkedList}
            setClientMarkedList={setClientMarkedList}
            allActive={allActive}
            setAllActive={setAllActive}
            setNullMarkedClients={setNullMarkedClients}
            rowClassName={rowClassName}
          />
        </div>
      ) : (
        tab === "Клиенты" && (
          <MobileClientsNew
            page={page}
            setPage={setPage}
            setPageSize={setPageSize}
            clientsList={clientsList}
            clientsListLoading={clientsListLoading}
            setClientInfo={setClientInfo}
            setIsOpenAddEditModal={setIsOpenAddEditModal}
            setIsOpenDeleteModal={setIsOpenDeleteModal}
            setTab={setTab}
            setTabPage={setTabPage}
            allActive={allActive}
            setAllActive={setAllActive}
            mnemo={mnemo}
            setClientMarkedList={setClientMarkedList}
            setIsOpenAddMailModal={setIsOpenAddMailModal}
          />
        )
      )}

      {clientInfo && (
        <ClientsExtraTable
          tabPage={tab}
          setTabPage={setTab}
          mnemo={mnemo}
          clientInfo={clientInfo}
          tab={tabPage}
          setTab={setTabPage}
          payload={addEditPayload}
        />
      )}
    </>
  )
}

export default ClientsNew